import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/BottomNavigation.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUsers, faCog } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';
import { useGroup } from '../../context/GroupContext';

const AdminBottomNav = () => {
  const location = useLocation();
  const { pathname } = location;
  const { currentUser } = useAuth();
  const { adminGroup, loading } = useGroup();

  const isActive = (path) => {
    if (path === '/') return pathname === '/dashboard' || pathname === '/';
    if (path === '/members') {
      return pathname.includes('members-admin');
    }
    return pathname.startsWith(path);
  };

  return (
    <>
      <nav className="bottom-navigation">
        <Link to="/dashboard" className={`nav-item ${isActive('/') ? 'active' : ''}`}>
          <FontAwesomeIcon icon={faHome} className="nav-icon" />
          <span className="nav-text">Home</span>
        </Link>
        
        <Link 
          to={adminGroup ? `/group/${adminGroup.id}/members-admin` : '/members'} 
          className={`nav-item ${isActive('/members') ? 'active' : ''}`}
        >
          <FontAwesomeIcon icon={faUsers} className="nav-icon" />
          <span className="nav-text">Members</span>
        </Link>
        
        <Link to="/account" className={`nav-item ${isActive('/account') ? 'active' : ''}`}>
          <FontAwesomeIcon icon={faCog} className="nav-icon" />
          <span className="nav-text">Account</span>
        </Link>
      </nav>
    </>
  );
};

export default AdminBottomNav;